import React from "react";

interface AudienceExternalTagProps {
    title: string;
    tag?: string;
}

export const AudienceExternalTag: React.FC<AudienceExternalTagProps> = props => {
    const { title, tag } = props;

    if (!tag) {
        return null;
    }

    return (
        <div className="space-y-1">
            <p className="text-sm">{title}</p>
            <div className="inline-block">
                <span className="bg-gray-100 text-gray-700 px-2 py-1 rounded text-sm">
                    {tag}
                </span>
            </div>
        </div>
    );
};
